var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"article-paywall"},[_c('client-only',[_c('iframe',{ref:_vm.paywallId,attrs:{"src":_vm.paywallUrl,"frameBorder":"0","width":"100%","scrolling":"no"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }